import { createIcon } from '@chakra-ui/icons'

const MOVIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <g transform="translate(5311 -4734.065)">
      <path
        d="M-5242.5 4817.5h-59c-2.5 0-4.5-2-4.5-4.5v-71c0-2.5 2-4.5 4.5-4.5h44.4l19.1 17.3v58.2c0 2.5-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M-5242.5 4817c2.2 0 4-1.8 4-4v-58l-18.8-17h-44.2c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5v-71c0-2.8 2.2-5 5-5h44.6l19.4 17.6v58.4c0 2.8-2.3 5-5 5z"
        fill="#E1E4EA"
      />
      <path
        d="M-5237.5 4767h-69v-25c0-2.8 2.2-5 5-5h45.6l18.4 17.5v12.5z"
        fill="#2EB8EC"
      />
      <path
        d="M-5255.8 4737.1v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0l-18.2-17.4z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(-5299.533 4756.032)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        MOV
      </text>
      <path
        fill="#E1E4EB"
        d="M-5256.6 4784.1h-14.9c.4-.1.7-.4.7-.8v-2.2c0-.5-.4-.9-.9-.9h-5v-1.7c0-.5-.4-.9-.9-.9h-4.1c-.5 0-.9.4-.9.9v1.7h-5c-.5 0-.9.4-.9.9v2.2c0 .4.3.8.7.8v19.6c-.4.1-.7.4-.7.8v2.2c0 .5.4.9.9.9h16c.5 0 .9-.4.9-.9v-2.2c0-.3-.2-.6-.5-.8h8.7c.6 0 1.1-.5 1.1-1.1v-1.2c0-2.9 2.3-5.2 5.2-5.2.5 0 .9-.4.9-.9v-10.2c-.3-.6-.7-1-1.3-1zm-15.9 19.5h-14.3V4784h14.3v19.6zm-9.2-25.1h4v1.6h-4v-1.6zm-5.8 2.6h15.7v1.9h-15.7v-1.9zm15.7 25.4h-15.7v-1.9h15.7v1.9zm15.3-11.2c-3.4.1-6 2.8-6 6.2v1.2s0 .1-.1.1h-8.8v-17.6h14.9s.1 0 .1.1v10z"
      />
      <path
        fill="#E1E4EB"
        d="M-5258.2 4786.3h-1.2c-.3 0-.5.2-.5.5s.2.5.5.5h1.2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
      />
      <path
        fill="#E1E4EB"
        d="M-5261.7 4786.3h-1.2c-.3 0-.5.2-.5.5s.2.5.5.5h1.2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
      />
      <path
        fill="#E1E4EB"
        d="M-5265.2 4786.3h-1.2c-.3 0-.5.2-.5.5s.2.5.5.5h1.2c.3 0 .5-.2.5-.5s-.3-.5-.5-.5z"
      />
      <path
        fill="#E1E4EB"
        d="M-5268.8 4786.3h-1.2c-.3 0-.5.2-.5.5s.2.5.5.5h1.2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
      />
      <path
        fill="#E1E4EB"
        d="M-5265.2 4800.3h-1.2c-.3 0-.5.2-.5.5s.2.5.5.5h1.2c.3 0 .5-.2.5-.5s-.3-.5-.5-.5z"
      />
      <path
        fill="#E1E4EB"
        d="M-5268.8 4800.3h-1.2c-.3 0-.5.2-.5.5s.2.5.5.5h1.2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
      />
    </g>
  ),
})

export default MOVIcon
